import phoneIco from "../../../assets/phone-ico.svg";
import mailIco from "../../../assets/mail-ico.svg";

import ContactForm from "./ContactForm";

export default function ContactUs() {
  return (
    <>
      <section id="contact_us">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-info">
              <h2 className="anim-text">Ready to Radiate?</h2>
              <div className="separator"></div>
              <div className="contain-info-wrap">
                <a href="tel:+971 (0) 50 690 7195">
                  <div className="contain-info__single--icon">
                    <img src={phoneIco} alt="phone-img" />
                  </div>
                  <div className="contain-info__single--text">
                    +971 (0) 50 690 7195
                  </div>
                </a>
                <a href="mailto:shine@smplsol.com">
                  <div className="contain-info__single--icon">
                    <img src={mailIco} alt="email-img" />
                  </div>
                  <div className="contain-info__single--text">
                    shine@smplsol.com
                  </div>
                </a>
              </div>
            </div>
            <div className="contact-form-wrap">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
